import React from 'react';
import {
  Autocomplete, Box, Checkbox, FormControlLabel, FormHelperText, Stack, Switch, TextField, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCubeCatalog } from 'api/bi';

// `value` is null for every model, otherwise the chosen cube names.
export default function ModelScopeField({ enabled, value, onChange, error = false, disabled = false }) {
  const { t } = useTranslation();
  const catalog = useCubeCatalog({ enabled });
  const cubes = Array.isArray(catalog.data) ? catalog.data : [];
  const unavailable = catalog.isError || (catalog.isSuccess && cubes.length === 0);
  const all = value === null;
  return (
    <Stack spacing={1}>
      <Typography variant="body2" fontWeight={600}>{t('connections.scopes')}</Typography>
      <FormControlLabel
        control={<Switch checked={all} onChange={(event) => onChange(event.target.checked ? null : [])} disabled={disabled || !catalog.isSuccess || unavailable} />}
        label={t('connections.allModels')}
      />
      {all && <FormHelperText sx={{ mt: 0 }}>{t(unavailable ? 'connections.modelsUnavailable' : catalog.isSuccess ? 'connections.allModelsHelp' : 'connections.modelsLoading')}</FormHelperText>}
      {!all && <Autocomplete
        multiple
        disableCloseOnSelect
        options={cubes}
        value={cubes.filter((cube) => value.includes(cube.name))}
        onChange={(event, next) => onChange(next.map((cube) => cube.name))}
        getOptionLabel={(cube) => cube.title}
        isOptionEqualToValue={(option, chosen) => option.name === chosen.name}
        noOptionsText={t('connections.modelsNotFound')}
        disabled={disabled}
        renderOption={({ key, ...props }, cube, { selected }) => (
          <li key={cube.name} {...props}>
            <Checkbox size="small" checked={selected} sx={{ mr: 1 }} />
            <Box>
              <Typography variant="body2">{cube.title}</Typography>
              {cube.title !== cube.name && <Typography variant="caption" color="text.secondary">{cube.name}</Typography>}
            </Box>
          </li>
        )}
        renderInput={(params) => <TextField {...params} label={t('connections.models')} error={error} helperText={error ? t('connections.modelsRequired') : undefined} />}
      />}
    </Stack>
  );
}
